import { call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import userAPI from '../../../../user/api/UserAPI';
import { FETCH_USER_UNLOCODE_SELECTIONS_REQUEST, DELETE_USER_UNLOCODE_SELECTION_REQUEST } from '../../../../user/redux/actions/types/UserActionTypes';
import {
  fetchUserUnlocodeSelectionsFailureActionCreator,
  fetchUserUnlocodeSelectionsSuccessActionCreator,
  deleteUserUnlocodeSelectionFailureActionCreator,
  deleteUserUnlocodeSelectionSuccessActionCreator,
} from '../../../../user/redux/actions/UserActions';
import { postPostalCountryUnlocode } from '../../api/PostalCountryUnlocodeApi';
import {
  departureUnlocodeCheckedActionCreator,
  retrieveOutboundPostalOperatorsUnlocodeFailureActionCreator,
  retrieveOutboundPostalOperatorsUnlocodeSuccessActionCreator,
} from '../actions/DeparturePostalOperatorActions';
import {
  arrivalUnlocodeCheckedActionCreator,
  retrieveInboundPostalOperatorsUnlocodeFailureActionCreator,
  retrieveInboundPostalOperatorsUnlocodeSuccessActionCreator,
} from '../actions/ArrivalPostalOperatorActions';
import { RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST } from '../actions/types/DeparturePostalOperatorActionTypes';
import { RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST } from '../actions/types/ArrivalPostalOperatorActionTypes';
import OperatorTypes from '../../../../common/redux/actions/types/OperatorTypes';
import DirectionTypes from '../../../../common/redux/actions/types/DirectionTypes';

function* retrieveOutboundPostalOperatorWorker(action) {
  let operatorType = action.payload.defaultDirection === DirectionTypes.INBOUND ? OperatorTypes.DEPARTURE : OperatorTypes.ARRIVAL;
  const stretch = action.payload.defaultDirection === DirectionTypes.OUTBOUND ? 'INBOUND' : 'OUTBOUND';
  try {
    const postalOperatorsResponse = yield call(postPostalCountryUnlocode, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(retrieveOutboundPostalOperatorsUnlocodeSuccessActionCreator(postalOperatorsResponse.data));

    if (action.departureCheckedUnlocodes && action.departureCheckedUnlocodes.length) return;

    let lastUserUnlocodeSelectionResponse = yield call(userAPI.getLastUserUnlocodeSelection, operatorType, action.payload.defaultDirection);
    let lastUserUnlocodeSelection = lastUserUnlocodeSelectionResponse.data;
    if ((stretch === 'OUTBOUND' && lastUserUnlocodeSelection.direction !== action.payload.defaultDirection) ||
        (stretch === 'INBOUND' && lastUserUnlocodeSelection.direction === action.payload.defaultDirection)) {
      operatorType = operatorType === OperatorTypes.DEPARTURE ?
        OperatorTypes.ARRIVAL : OperatorTypes.DEPARTURE;
      lastUserUnlocodeSelectionResponse = yield call(userAPI.getLastUserUnlocodeSelection, operatorType, action.payload.defaultDirection);
      lastUserUnlocodeSelection = lastUserUnlocodeSelectionResponse.data;
    }

    if (lastUserUnlocodeSelection && action.reportDefinition !== 'Admin') {
      if (stretch === 'OUTBOUND') {
        if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
          yield put(departureUnlocodeCheckedActionCreator(
            lastUserUnlocodeSelection.unlocodes,
            action.reportDefinition,
          ));
        } else {
          yield put(arrivalUnlocodeCheckedActionCreator(
            lastUserUnlocodeSelection.unlocodes,
            action.reportDefinition,
          ));
        }
      } else if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
        yield put(arrivalUnlocodeCheckedActionCreator(
          lastUserUnlocodeSelection.unlocodes,
          action.reportDefinition,
        ));
      } else {
        yield put(departureUnlocodeCheckedActionCreator(
          lastUserUnlocodeSelection.unlocodes,
          action.reportDefinition,
        ));
      }
    }
  } catch (error) {
    yield put(retrieveOutboundPostalOperatorsUnlocodeFailureActionCreator(error));
  }
}

function* retrieveInboundPostalOperatorWorker(action) {
  let operatorType = action.payload.defaultDirection === DirectionTypes.INBOUND ? OperatorTypes.ARRIVAL : OperatorTypes.DEPARTURE;
  const stretch = action.payload.defaultDirection === DirectionTypes.INBOUND ? 'INBOUND' : 'OUTBOUND';
  try {
    const postalOperatorsResponse = yield call(postPostalCountryUnlocode, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(retrieveInboundPostalOperatorsUnlocodeSuccessActionCreator(postalOperatorsResponse.data));

    if (action.arrivalCheckedUnlocodes && action.arrivalCheckedUnlocodes.length) return;

    let lastUserUnlocodeSelectionResponse = yield call(userAPI.getLastUserUnlocodeSelection, operatorType, action.payload.defaultDirection);
    let lastUserUnlocodeSelection = lastUserUnlocodeSelectionResponse.data;
    if ((stretch === 'INBOUND' && lastUserUnlocodeSelection.direction !== action.payload.defaultDirection) ||
        (stretch === 'OUTBOUND' && lastUserUnlocodeSelection.direction === action.payload.defaultDirection)) {
      operatorType = operatorType === OperatorTypes.DEPARTURE ? OperatorTypes.ARRIVAL : OperatorTypes.DEPARTURE;
      lastUserUnlocodeSelectionResponse = yield call(userAPI.getLastUserUnlocodeSelection, operatorType, action.payload.defaultDirection);
      lastUserUnlocodeSelection = lastUserUnlocodeSelectionResponse.data;
    }

    if (lastUserUnlocodeSelection && action.reportDefinition !== 'Admin') {
      if (stretch === 'INBOUND') {
        if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
          yield put(arrivalUnlocodeCheckedActionCreator(
            lastUserUnlocodeSelection.unlocodes,
            action.reportDefinition,
          ));
        } else {
          yield put(departureUnlocodeCheckedActionCreator(
            lastUserUnlocodeSelection.unlocodes,
            action.reportDefinition,
          ));
        }
      } else if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
        yield put(departureUnlocodeCheckedActionCreator(
          lastUserUnlocodeSelection.unlocodes,
          action.reportDefinition,
        ));
      } else {
        yield put(arrivalUnlocodeCheckedActionCreator(
          lastUserUnlocodeSelection.unlocodes,
          action.reportDefinition,
        ));
      }
    }
  } catch (error) {
    yield put(retrieveInboundPostalOperatorsUnlocodeFailureActionCreator(error));
  }
}

function* fetchUserUnlocodeSelectionsWorker(action) {
  try {
    const postalOperatorType = action.payload;

    const userUnlocodeSelectionsResponse = yield call(
      userAPI.getUserUnlocodeSelections,
      postalOperatorType,
    );
    const selections = userUnlocodeSelectionsResponse.data;

    yield put(fetchUserUnlocodeSelectionsSuccessActionCreator(postalOperatorType, selections));
  } catch (error) {
    yield put(fetchUserUnlocodeSelectionsFailureActionCreator(error));
  }
}

function* deleteUserUnlocodeSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserUnlocodeSelection, action.payload);
    yield put(deleteUserUnlocodeSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserUnlocodeSelectionFailureActionCreator(error));
  }
}

function* postalOperatorsWatcher() {
  yield takeLeading(RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST, retrieveOutboundPostalOperatorWorker);
  yield takeLeading(RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST, retrieveInboundPostalOperatorWorker);
  yield takeEvery(FETCH_USER_UNLOCODE_SELECTIONS_REQUEST, fetchUserUnlocodeSelectionsWorker);
  yield takeEvery(DELETE_USER_UNLOCODE_SELECTION_REQUEST, deleteUserUnlocodeSelectionsWorker);
}

export default postalOperatorsWatcher;
